import { Box } from "@mui/material";

import ManagementTrendSection from "../ManagementTrendSection";
import OperationalReadinessSection from "../OperationalReadinessSection";
import CriticalCasesTable from "../components/CriticalCasesTable";
import BottleneckHeatmap from "../components/BottleneckHeatmap";
import StageAgingMatrix from "../components/StageAgingMatrix";

const OperationsControlTab = ({
  readinessLoading,
  readinessError,
  readinessData,
  stageAgingLoading,
  stageAgingError,
  stageAgingData,
  criticalCasesLoading,
  criticalCasesError,
  criticalCasesData,
  bottlenecksLoading,
  bottlenecksError,
  bottlenecksData,
  trendLoading,
  trendError,
  trendSeries,
  metricGroup,
  resolvedTrendMetric,
  handleTrendGroupChange,
  handleTrendMetricChange,
  dashboardFilters,
  loadReadiness,
  loadStageAging,
  loadCriticalCases,
  loadOperationalBottlenecks,
  loadTrends,
}) => (
  <Box>
    <OperationalReadinessSection
      loading={readinessLoading}
      error={readinessError}
      data={readinessData}
      onRetry={() => loadReadiness(dashboardFilters)}
    />

    <StageAgingMatrix
      loading={stageAgingLoading}
      error={stageAgingError}
      data={stageAgingData}
      onRetry={() => loadStageAging(dashboardFilters)}
    />

    <BottleneckHeatmap
      loading={bottlenecksLoading}
      error={bottlenecksError}
      data={bottlenecksData}
      onRetry={() => loadOperationalBottlenecks(dashboardFilters)}
    />

    <CriticalCasesTable
      loading={criticalCasesLoading}
      error={criticalCasesError}
      data={criticalCasesData}
      dashboardFilters={dashboardFilters}
      onReload={loadCriticalCases}
    />

    <ManagementTrendSection
      loading={trendLoading}
      error={trendError}
      seriesList={trendSeries}
      metricGroup={metricGroup}
      selectedMetricCode={resolvedTrendMetric}
      onMetricGroupChange={handleTrendGroupChange}
      onMetricChange={handleTrendMetricChange}
      onRetry={() => loadTrends(dashboardFilters)}
    />
  </Box>
);

export default OperationsControlTab;
